/* global graphql */
import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bs-grid';
import BodyClassName from 'react-body-classname';
import Helmet from 'react-helmet';
import { ChevronUp } from 'react-feather';
import Link from 'gatsby-link';
import WindowSize from 'react-window-size';
import get from 'lodash/get';
import { Fab, FabButton } from 'react-fab';

import Space from '../components/Space';
import Title from '../components/Title';
import Page from '../components/Page';

class Element extends Component {
  componentDidMount() {
    if (Prism) Prism.highlightAll();
  }

  getDocs() {
    const edges = get(this.props, 'data.allMarkdownRemark.edges');
    if (!edges) return '';
    const { html } = edges.filter(edge => edge.node.html.indexOf('name="guides"') > -1)[0].node;
    return html.slice(html.indexOf('<h2>'));
  }

  getSideLength() {
    const { windowWidth } = this.props;
    let sideLength = 340;
    if (windowWidth < 1200) sideLength = 270;
    if (windowWidth < 992) sideLength = 210;
    if (windowWidth < 768) sideLength = 258;
    if (windowWidth < 570) sideLength = windowWidth - 100;
    if (windowWidth === 0) sideLength = 340;
    return sideLength;
  }

  scrollTo(key) {
    return () => {
      document.querySelector(`[name="layouts__${key}"]`).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      });
    };
  }

  render() {
    return (
      <BodyClassName className={'no-padding'}>
        <Page fluid name="page-build">
          <Helmet
            title="Potion.js - React + D3"
            meta={[
              {
                property: 'og:url',
                content: 'http://numberpicture.com/build',
              },
              {
                property: 'og:title',
                content: 'Potion.js - React + D3',
              },
              {
                property: 'og:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                name: 'twitter:title',
                content: 'Potion.js - React + D3',
              },
              {
                name: 'twitter:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                charSet: 'utf-8',
              },
            ]}
          />

          <Fab style={{ right: '20px', bottom: '20px' }}>
            <FabButton>
              <a onClick={this.scrollTo('top')}>
                <ChevronUp />
              </a>
            </FabButton>
          </Fab>

          <Container fluid>
            <Row>
              <Container>
                <Row>
                  <Col lg={12}>
                    <div name="layouts__top" />
                    <Title>Guides</Title>
                  </Col>
                </Row>
                <Row>
                  <Col lg={8}>
                    <p>Here you will find guides for using features of Potion in powerful and alternative ways.</p>
                  </Col>
                  <Space half />
                </Row>

                <div className="page page-docs">
                  <div className="content">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.getDocs(),
                      }}
                    />
                  </div>
                </div>

                <Space />
                <Space />

              </Container>
            </Row>
          </Container>
        </Page>
      </BodyClassName>
    );
  }
}

export default WindowSize(Element);

export const pageQuery = graphql`
  query GuidesQuery {
    allMarkdownRemark {
      edges {
        node {
          html
          headings {
            depth
            value
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/guides.js